import { updateObject, getIndex } from './../../utils/utility';
import update from 'immutability-helper';

const initialState = {
    teamList: [],    
    listRefreshed: true,
    apiFetchError: false,
    acceptInviteSuccess: false,
    fetchingMembersForTeamId: null,
    acceptInviteCallComplete: false
};


const setTeamList = (state = initialState, action) => {
    return updateObject(state, { 
            teamList: action.payload,
            listRefreshed: true,
            apiFetchError: false
        }
    );
}

const setTeamMembers = (state = initialState, action) => {
    const { members, teamId } = action.payload;
    const teamIndex =  getIndex(state.teamList, "teamId", teamId);
    
    if (teamIndex === -1) return state;
    
    return updateObject(state, {
        teamList : update(state.teamList, {[teamIndex]: {members: {$set: members}}}),
        fetchingMembersForTeamId: null
    });;
}

const setListRefreshed = (state = initialState, action) => {
    return updateObject(state, {
        listRefreshed : action.data
    });
}

const setAPIFetchError = (state = initialState, action) => {
    return updateObject(state, {
        apiFetchError : action.data
    });
}

const setAcceptInviteSuccess = (state = initialState, action) => {
    return updateObject(state, {
        acceptInviteSuccess : action.data
    });
}

const setAcceptInviteCallComplete = (state = initialState, action) => {
    return updateObject(state, {
        acceptInviteCallComplete : action.data
    });
}

const setFetchingMembersForTeamId = (state = initialState, action) => {
    return updateObject(state, {
        fetchingMembersForTeamId : action.data
    });
}

const reducer = (state = initialState, action) => {
    if (action.type === "SET_TEAM_LIST") {
        return setTeamList(state, action);
    }
    if (action.type === "SET_TEAM_MEMBERS") {
        return setTeamMembers(state, action);
    }
    if (action.type === "SET_LIST_REFRESHED") {
        return setListRefreshed(state, action);
    }
    if (action.type === "SET_API_FETCH_ERROR") {
        return setAPIFetchError(state, action);
    }
    if (action.type === "SET_FETCHING_MEMBERS_FOR_TEAM_ID") {
        return setFetchingMembersForTeamId(state, action);
    }
    if (action.type === "SET_ACCEPT_INVITE_SUCCESS") {
        return setAcceptInviteSuccess(state, action);
    }
    if (action.type === "SET_ACCEPT_INVITE_CALL_COMPLETE") {
        return setAcceptInviteCallComplete(state, action);
    }
    return state;
}

export default reducer;